module.exports = __webpack_public_path__ + "static/media/checkmark-box-grey.4d40fc88.svg";